"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FeatureFlagsCharm_1 = require("./FeatureFlagsCharm");
exports.FeatureFlagsCharm = FeatureFlagsCharm_1.default;
var SkypeCharm_1 = require("./SkypeCharm");
exports.SkypeCharm = SkypeCharm_1.default;
//# sourceMappingURL=lazyCharms.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/header/owa-header/lib/components/lazyCharms.js
// module id = 2084
// module chunks = 42